var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.875,
    width: 27,
    height: 27,
    rx: 6,
    fill: "#5570F1",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3821_34268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0149 9.53589H21.1375C21.8223 9.53589 21.9987 9.70236 21.9995 10.3537C21.9995 13.4856 21.9995 16.6176 21.9995 19.7496C21.9995 20.341 21.7996 20.5336 21.182 20.5336C16.3937 20.5336 11.6053 20.5336 6.817 20.5336C6.19054 20.5336 6.00276 20.3525 6.00195 19.7526C6.00195 16.6079 6.00195 13.4626 6.00195 10.3168C6.00195 9.70312 6.17031 9.53666 6.81134 9.53589C9.21253 9.53231 11.6137 9.53231 14.0149 9.53589ZM14.0028 9.88877C11.6304 9.88877 9.25812 9.89338 6.8858 9.88417C6.51267 9.88417 6.36132 9.98773 6.36294 10.3667C6.37751 12.9474 6.36941 15.528 6.37427 18.1087C6.37427 18.2276 6.29818 18.3994 6.44226 18.4585C6.58633 18.5175 6.66484 18.3495 6.75468 18.2644C7.94853 17.139 9.14805 16.0167 10.3249 14.8744C10.5791 14.6274 10.7118 14.6397 10.9587 14.879C12.1355 16.0197 13.3399 17.1352 14.52 18.2736C14.7684 18.5137 14.9247 18.5175 15.1723 18.2736C16.0546 17.4129 16.9635 16.5752 17.8498 15.7175C18.057 15.5165 18.1841 15.5088 18.3986 15.7175C19.3391 16.6319 20.2974 17.5302 21.2533 18.4301C21.3431 18.5145 21.4281 18.6817 21.5681 18.6196C21.7081 18.5574 21.6329 18.3894 21.6329 18.2682C21.6361 15.66 21.6361 13.0535 21.6329 10.4488C21.6329 9.91179 21.6086 9.888 21.0388 9.888C18.6915 9.88852 16.3462 9.88877 14.0028 9.88877Z",
    fill: "#0F6CBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0814 11.8233C16.2126 11.8233 16.3425 11.8484 16.4632 11.897C16.584 11.9457 16.6932 12.0168 16.7843 12.1063C16.8754 12.1958 16.9465 12.3018 16.9935 12.4179C17.0404 12.534 17.0622 12.6579 17.0575 12.7822C17.0573 12.9068 17.0311 13.0302 16.9803 13.1452C16.9295 13.2601 16.8552 13.3644 16.7617 13.452C16.6681 13.5396 16.5572 13.6087 16.4353 13.6555C16.3134 13.7022 16.1829 13.7256 16.0515 13.7243C15.9165 13.7266 15.7825 13.7025 15.6579 13.6535C15.5332 13.6044 15.4205 13.5316 15.3269 13.4394C15.2333 13.3472 15.1608 13.2378 15.1139 13.1178C15.067 12.9979 15.0467 12.87 15.0543 12.7423C15.0672 12.2099 15.5067 11.8179 16.0814 11.8233Z",
    fill: "#0F6CBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3821_34268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 11,
    fill: "white",
    transform: "translate(6 9.53516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/Images.c4e2db5a62f674c8a0dc37e83a142c39.svg";
export { ForwardRef as ReactComponent };